import React from "react";
import PropTypes from "prop-types";
import { Route, Router } from "react-router";
import { Switch } from "react-router-dom";
import { AuthRoute } from "../features";
import { Logon, Logout, Platforms } from "../pages";
import { ROUTE } from "../constants";

function AppRouter({
  children,
  history
}) {
  return /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: ROUTE.PLATFORMS,
    component: Platforms
  }), /*#__PURE__*/React.createElement(AuthRoute, {
    path: ROUTE.LOGON_PAGE,
    type: "guest",
    component: Logon
  }), /*#__PURE__*/React.createElement(Route, {
    path: ROUTE.LOGOUT_PAGE,
    component: Logout
  }), /*#__PURE__*/React.createElement(AuthRoute, {
    type: "private"
  }, children)));
}

AppRouter.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object
};
export default AppRouter;